import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

const giftCardAdapter = createEntityAdapter({
  selectId: (card) => String(card.id),
});

const initialState = {
  byCountry: {},
  selectedCountryCode: '',
};

const giftCardCatalogueSlice = createSlice({
  name: 'giftCardCatalogue',
  initialState,
  reducers: {
    setCatalogueForCountry: (state, action) => {
      const { countryCode = '', records = [] } = action.payload || {};
      const key = countryCode || 'ALL';
      const baseState =
        state.byCountry[key] || giftCardAdapter.getInitialState();
      // Assign the result to ensure nested updates are applied correctly
      state.byCountry[key] = giftCardAdapter.setAll(baseState, records);
    },
    upsertCatalogueRecord: (state, action) => {
      const { countryCode = '', record } = action.payload || {};
      if (!record) return;
      const key = countryCode || 'ALL';
      const baseState =
        state.byCountry[key] || giftCardAdapter.getInitialState();
      state.byCountry[key] = giftCardAdapter.upsertOne(baseState, record);
    },
    setSelectedCountryCode: (state, action) => {
      const value = action.payload || '';
      state.selectedCountryCode = typeof value === 'string'
        ? value.trim().toUpperCase()
        : String(value).trim().toUpperCase();
    },
  },
});

export const {
  setCatalogueForCountry,
  upsertCatalogueRecord,
  setSelectedCountryCode,
} =
  giftCardCatalogueSlice.actions;

const selectCountryState = (state, countryCode) => {
  const key = countryCode || 'ALL';
  return state.giftCardCatalogue.byCountry[key] || giftCardAdapter.getInitialState();
};

export const selectGiftCardById = (state, countryCode, id) => {
  const selectors = giftCardAdapter.getSelectors((state) =>
    selectCountryState(state, countryCode),
  );
  return selectors.selectById(state, String(id));
};

export const selectGiftCardsForCountry = (state, countryCode) => {
  const selectors = giftCardAdapter.getSelectors((state) =>
    selectCountryState(state, countryCode),
  );
  return selectors.selectAll(state);
};

export const selectSelectedCountryCode = (state) =>
  state.giftCardCatalogue.selectedCountryCode;

export default giftCardCatalogueSlice.reducer;
